// Import Font Awesome icons selectively to reduce prod bundle size (https://docs.fontawesome.com/web/dig-deeper/kit-package-api)
/*
	Important: 
	Using individual FA pro npm packages instead of '@awesome.me/kit-2feb9bdff9/icons/*' 
	because '@awesome.me/kit-*' these packages are not tree-shakeable, even if you import individual icons.
	That's why it was growing bundle size significantly.
*/
import {
	faMagnifyingGlass,
	faFilter,
	faCircleChevronUp,
	faCircleChevronDown,
	faChevronUp,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faEnvelope,
	faTicket,
	faCircleExclamation,
	faUsers,
	faAngleRight,
	faThumbsUp,
	faQrcode,
	faEye,
	faEyeSlash,
	faPlus,
	faXmark,
	faPenToSquare,
	faFloppyDisk,
	faCircleCheck,
	faCircleXmark,
	faGripDotsVertical,
	faCreditCard,
	faArrowUpRightAndArrowDownLeftFromCenter,
	faArrowDownLeftAndArrowUpRightToCenter,
	faSquare,
	faFileInvoice,
	faMicrophone,
	faMicrophoneSlash,
	faCircleQuestion,
	faCalendarAlt,
	faClock,
	faStopwatch,
	faCalendarDays,
} from '@fortawesome/pro-regular-svg-icons'

import {
	faForward,
	faPenToSquare as faPenToSquareSolid,
	faUserCheck,
	faCircleCheck as faCircleCheckSolid,
	faCircleXmark as faCircleXmarkSolid,
	faUserXmark,
	faRotateRight,
	faChevronUp as faChevronUpSolid,
	faWifiExclamation,
	faKey,
	faCircleExclamation as faCircleExclamationSolid,
	faLocationDot,
} from '@fortawesome/pro-solid-svg-icons'

import { faGrid2 } from '@fortawesome/sharp-regular-svg-icons'

// Export them with clear labels

// Regular (https://fontawesome.com/search?f=classic&s=regular)
export const farIcons = {
	faMagnifyingGlass,
	faFilter,
	faCircleChevronUp,
	faCircleChevronDown,
	faChevronUp,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faEnvelope,
	faTicket,
	faCircleExclamation,
	faUsers,
	faAngleRight,
	faArrowUpRightAndArrowDownLeftFromCenter,
	faArrowDownLeftAndArrowUpRightToCenter,
	faThumbsUp,
	faQrcode,
	faEye,
	faEyeSlash,
	faPlus,
	faXmark,
	faFloppyDisk,
	faCircleCheck,
	faCircleXmark,
	faPenToSquare,
	faGripDotsVertical,
	faCreditCard,
	faSquare,
	faFileInvoice,
	faMicrophone,
	faMicrophoneSlash,
	faCircleQuestion,
	faCalendarAlt,
	faClock,
	faLocationDot,
	faStopwatch,
	faCalendarDays,
	// Add more regular icons as needed
}

// Solid (https://fontawesome.com/search?f=classic&s=solid)
export const fasIcons = {
	faForward,
	faUserCheck,
	faUserXmark,
	faPenToSquare: faPenToSquareSolid,
	faRotateRight,
	faCircleXmark: faCircleXmarkSolid,
	faCircleCheck: faCircleCheckSolid,
	faChevronUpSolid,
	faWifiExclamation,
	faKey,
	faCircleExclamation: faCircleExclamationSolid,

	// Add more solid icons as needed
}

// Sharp Regular (https://fontawesome.com/search?f=sharp&s=regular)
export const fasrIcons = {
	faGrid2,

	// Add more sharp regular icons as needed
}
